import type { AgentReport } from '@ralph/contracts'

/**
 * The order the report dialog offers the contract's categories in — most serious first.
 *
 * It lives here rather than beside the sentences in each locale's `marketplace/report`
 * namespace, because it is not copy (PRD-27 LOC-017, D-25). Ordering is a product decision
 * that is the same in every language, and a constant sitting inside a locale-keyed
 * catalogue is a constant that can drift per locale: a pt-BR file copied from the English
 * one and then edited would reorder — or silently drop — a category for Portuguese readers
 * only, with nothing failing. The words for each value stay in the catalogue; the list of
 * values stays here.
 *
 * `satisfies readonly ReportCategory[]` rather than a bare array, so a sixth member of the
 * contract enum is a compile error in the catalogue AND a visible omission here, instead of
 * a category that exists in the API and can never be chosen.
 */
export const REPORT_CATEGORIES = [
  'impersonation',
  'harmful',
  'wrong',
  'inappropriate',
  'other'
] as const satisfies readonly AgentReport['category'][]
